import React, { ReactNode } from "react";

import Box from "veneer/Box";
import { Colors } from "veneer/Theme";
import Typography from "veneer/Typography";

import { LoadingIndicator } from "cortex/ui/src/ui/loader";

interface WidgetContainerProps {
  children: ReactNode;
  dataTestId?: string;
  loading?: boolean;
  title?: string;
}

export default function WidgetContainer({
  children,
  dataTestId,
  loading = false,
  title,
}: WidgetContainerProps) {
  return (
    <Box
      bgcolor={Colors.white}
      borderRadius={2}
      dataTestId={dataTestId}
      display="flex"
      flexDirection="column"
      flexGrow={1}
      py={1}
    >
      {title && (
        <Typography color={Colors.gray1000} mb={1} px={1} variant="h5">
          {title}
        </Typography>
      )}
      {loading ? (
        <Box p={2}>
          <LoadingIndicator />
        </Box>
      ) : (
        children
      )}
    </Box>
  );
}
